import { render } from "./DohBlocking.vue?vue&type=template&id=4ab1510e&scoped=true"
import script from "./DohBlocking.vue?vue&type=script&lang=js"
export * from "./DohBlocking.vue?vue&type=script&lang=js"

import "./DohBlocking.vue?vue&type=style&index=0&id=4ab1510e&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab1510e"]])

export default __exports__